export { default } from './StarRatingComponent';
